import axios from 'axios';
import api from '../ApiAuthService';

export async function getClassifiedFilters(filters: any): Promise<any> {
  try {
    const response = await api.post('/posts/classifieds/filters', filters);
    return response;
    
  } catch (error) {
    console.error('Erro ao carregar a página', error);
    // throw new Error('Erro ao carregar a página');
  }
}

export async function getEventsFilters(filters: any): Promise<any> {
  try {
    const response = await api.post('/posts/events/filters', filters);
    return response;
    
  } catch (error) {
    console.error('Erro ao carregar a página', error);
    // throw new Error('Erro ao carregar a página');
  }
}

export async function getTipsFilters(filters: any): Promise<any> {
  try {
    const response = await api.post('/posts/tips/filters', filters);
    return response;
    
  } catch (error) {
    console.error('Erro ao carregar a página', error);
    // throw new Error('Erro ao carregar a página');
  }
}

export async function getPartnershipsFilters(filters: any): Promise<any> {
  try {
    const response = await api.post('/posts/partnerships/filters', filters);
    return response;
    
  } catch (error) {
    console.error('Erro ao carregar a página', error);
    // throw new Error('Erro ao carregar a página');
  }
}

